import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { fetchOrder } from 'entities/Order';
import { editOrderItem } from 'features/editItemsInOrder/model/services/editOrderItem/editOrderItem';
import { deleteOrderItem } from 'features/removeItemsInOrder/model/services/deleteOrderItem/deleteOrderItem';

import { buildSellersDataBySeller } from '../lib/buildSellersDataBySeller';
import { OrderProposalFilterSchema } from '../types/OrderProposalFilterSchema';

const initialState: OrderProposalFilterSchema = {
    orderItems: [],
    filter: 'All',
    filteredItems: [],
    filterSellersDataBySeller: {},
};

export const OrderProposalFilterSlice = createSlice({
    name: 'OrderProposalFilter',
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<string>) => {
            state.filter = action.payload;
        },
        setFilteredItems: (state, action) => {
            state.filteredItems = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrder.fulfilled, (state, action) => {
                const { data } = action.payload;

                state.orderItems = data.items;
                state.filterSellersDataBySeller = buildSellersDataBySeller(
                    data.items,
                );
            })
            .addCase(deleteOrderItem.fulfilled, (state, action) => {
                const deletedItem = action.payload;

                const newOrderItems = [...state.orderItems];
                const foundIndex = newOrderItems.findIndex(
                    (item) => item.id === deletedItem.id,
                );

                if (foundIndex || foundIndex === 0) {
                    newOrderItems.splice(foundIndex, 1);
                }

                state.orderItems = newOrderItems;
                state.filterSellersDataBySeller =
                    buildSellersDataBySeller(newOrderItems);
            })
            .addCase(editOrderItem.fulfilled, (state, action) => {
                const editedItem = action.payload;
                const newOrderItems = [...state.orderItems];
                const foundIndex = newOrderItems.findIndex(
                    (item) => item.id === editedItem.id,
                );

                if (foundIndex || foundIndex === 0) {
                    newOrderItems[foundIndex] = editedItem;
                }

                state.orderItems = newOrderItems;
                state.filterSellersDataBySeller =
                    buildSellersDataBySeller(newOrderItems);
            });
    },
});

export const { actions: orderProposalFilterActions } = OrderProposalFilterSlice;
export const { reducer: orderProposalFilterReducer } = OrderProposalFilterSlice;
